<div>
    <div>
        <div class="form-group row">
            <div class="col-lg-6">
                <label class="checkbox">
                    <input type="checkbox"
                           [(ngModel)]="doNotHaveSubordinates">
                    <span></span>
                    {{"doNotHaveSubordinates" | localize}}
                </label>
            </div>
            <div class="col-lg-6 text-right">
                <button [disabled]="doNotHaveSubordinates"
                        class="btn btn-primary blue"
                        (click)="openSelectUserModal()"
                        type="button"><i class="fa fa-search"></i>
                    {{l("SubordinateSearch")}}
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="!doNotHaveSubordinates">
        <div class="pt-5 mt-2"
             *ngIf="directReportsLookup.selectedSubordinaries.length > 0 else noData">
            <table class="table">
                <tr>
                    <th>{{ l('FirstName') }}</th>
                    <th>{{ l('LastName')}}</th>
                    <th></th>
                </tr>
                <tr *ngFor="let person of directReportsLookup.selectedSubordinaries">
                    <td>{{ person.contactDetails.firstName }}</td>
                    <td>{{ person.contactDetails.lastName }}</td>
                    <td class="text-right"
                        style="max-width: 100px;">
                        <button
                            class="btn btn-xs btn-danger float-right"
                            (click)="directReportsLookup.toggleSubordinary(person)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </table>

        </div>

        <ng-template #noData>
            <div class="-mb-5 alert alert-info background-transparent">
                {{ l('noSubordinatesSelected') }}
            </div>
        </ng-template>
    </div>

    <button (click)="save()"
            class="btn btn-primary blue float-right"
            [buttonBusy]="saving"
            [busyText]="l('SavingWithThreeDot')"><i class="fa fa-save"></i>
        <span>{{l("Save")}}</span>
    </button>
</div>

<directReportsUserLookupTableModal
    #directReportsLookup
    (modalSave)="getNewUserId()" [ownDetailsEdit]="ownDetailsEdit">
</directReportsUserLookupTableModal>
